<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    List of Active Distributor
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn
                    v-if="getDashboardRole.code === $verifier"
                    color="primary"
                    @click="addDistributor()"
                  >
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <AddDistributorDialog ref="addDistributorDialog" />
  </v-container>
</template>

<script>
// import moment from "moment";
import AddDistributorDialog from "../dialogs/serviceProvider/AddDistributorDialog.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  mixins: [ShareableMethods],
  name: "DistributorList",
  components: {
    AddDistributorDialog,
  },
  data() {
    return {
      search: "",
      table: {
        // sortBy: "dtCreated",

        headers: [
          {
            text: "Distributor",
            value: "companyName",
          },

          {
            text: "Created By",
            value: "createdBy",
            sortable: false,
          },

          {
            text: "Approved By",
            value: "approvedBy",
            sortable: false,
          },

          {
            text: "Verified By",
            value: "verifiedBy",
            sortable: false,
          },

          {
            text: "Current Load Balance",
            value: "currentLoadBalance",
            sortable: false,
            align: "center",
            // formatter: function (x) {
            //   if (x) {
            //     var formatter = new Intl.NumberFormat("en-US", {
            //       style: "currency",
            //       currency: "PHP",
            //     });
            //     return formatter.format(x);
            //   }
            //   return 0;
            // },
            formatter: (x) => (x ? this.setToLocaleString(x) : 0),
          },

          {
            text: "Current Install Balance",
            value: "currentInstallBalance",
            sortable: false,
            align: "center",
            // formatter: function (x) {
            //   if (x) {
            //     var formatter = new Intl.NumberFormat("en-US", {
            //       style: "currency",
            //       currency: "PHP",
            //     });
            //     return formatter.format(x);
            //   }
            //   return 0;
            // },
            formatter: (x) => (x ? this.setToLocaleString(x) : 0),
          },
        ],
        sortDesc: true,
        loading: false,
        data: [],
      },
    };
  },

  methods: {
    async getList() {
      const endPoint =
        this.getDashboardRole.code === this.$verifier
          ? "verified-distributors"
          : "approved-distributors";
      this.table.loading = true;
      await this.$drs
        .get(`/broker/drs/${endPoint}`)
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr.list;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async addDistributor() {
      await this.$refs.addDistributorDialog.open().then((result) => {
        if (result) {
          this.getList();
        }
      });
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    getDashboardRole() {
      return this.$store.getters.dashboardRole;
    },
  },
};
</script>
